"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidBuildType = exports.InvalidSerialNumber = exports.InvalidBuildFile = exports.Builds = exports.JobRequest = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const json_1 = require("../../../../../../../json");
const Device = __importStar(require("../../../../../../device"));
const openapi_1 = require("../../../../../openapi");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Ota.Schema';
/**
 * `isInt` accepts a number or an integer string. Spaces, a decimal point and
 * an exponent are 422. The handler stores whichever of the two arrived.
 */
const integerString = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[-+]?\d+$/), effect_1.Schema.compose(effect_1.Schema.NumberFromString), effect_1.Schema.int());
const numericInt = (minimum, maximum) => maximum === undefined
    ? effect_1.Schema.Union(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(minimum)), integerString.pipe(effect_1.Schema.greaterThanOrEqualTo(minimum)))
    : effect_1.Schema.Union(effect_1.Schema.Int.pipe(effect_1.Schema.between(minimum, maximum)), integerString.pipe(effect_1.Schema.between(minimum, maximum)));
exports.JobRequest = effect_1.Schema.Struct({
    buildFile: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Build file name. A value that is not a string, or an empty one, is 422.',
    }),
    maxAttempts: effect_1.Schema.optionalWith(numericInt(1, 50), { exact: true }).annotations({
        description: 'A number or an integer string, from 1 to 50. A string with spaces, a decimal point or an exponent is 422. Stored as 50 when omitted.',
    }),
    retryInterval: effect_1.Schema.optionalWith(numericInt(600), { exact: true }).annotations({
        description: 'Seconds between attempts, a number or an integer string, at least 600. A string with spaces, a decimal point or an exponent is 422. Stored as 1800 when omitted.',
    }),
    notificationTriggers: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.Literal('completed', 'failed')), {
        exact: true,
    }).annotations({
        description: 'Stored as an empty array when omitted.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.JobRequest`,
});
exports.Builds = effect_1.Schema.Struct({
    builds: effect_1.Schema.Array(Device.Ota.Build),
}).annotations({
    identifier: `${exports.NAMESPACE}.Builds`,
    description: 'OTA builds for the device model, encoded as Culligan.Device.Ota.Build.',
});
/**
 * 422: `otaBuildService.get` threw. That is a missing build, and also a database or
 * decode failure. The caught value is spread after `message`, so a decode
 * failure also carries `_tag` and `issue`.
 */
exports.InvalidBuildFile = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(false),
    error: effect_1.Schema.Struct({ message: effect_1.Schema.Literal('INVALID_BUILD_FILE') }, effect_1.Schema.Record({ key: effect_1.Schema.String, value: json_1.Value })),
}).annotations({
    identifier: `${exports.NAMESPACE}.InvalidBuildFile`,
    title: 'Invalid build file',
    description: 'The build lookup failed. A missing build, a database error and a decode error all use this status. The caught value is spread onto the error object.',
    [platform_1.HttpApiSchema.AnnotationStatus]: 422,
});
/** 422: the serial number does not encode a model. */
exports.InvalidSerialNumber = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidSerialNumber`, 'INVALID_SERIAL_NUMBER', 'Invalid serial number', 'The device serial number does not encode a model.');
/** 422: the build is for a different model than the device. */
exports.InvalidBuildType = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidBuildType`, 'INVALID_BUILD_TYPE', 'Invalid build type', 'The build model and the device model differ.', {
    build: effect_1.Schema.Struct({
        model: effect_1.Schema.String,
        deviceModel: effect_1.Schema.String,
    }),
});
//# sourceMappingURL=schema.js.map